<template>
  <div class="relative h-8">
    <input
        ref="inputRef"
        v-model="inputValue"
        type="text"
        :placeholder="placeholder"
        class="pl-2 pr-4 h-8 outline-0 focus:outline-none"
        :class="props.class"
        @input="emitUpdate"
        @keyup.enter="onEnter"
        :data-ui="dataUi"
    />
    <button
        v-if="inputValue"
        :data-ui="dataUi + '-clear'"
        class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
        @click="clearInput"
    >
      <i class="fas fa-times"></i>
    </button>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, defineProps, defineEmits } from 'vue';

// Define props
const props = defineProps({
  modelValue: String,
  placeholder: String,
  inputClass: String,
  class: String,
  dataUi: String,
  focusAfterClear: {
    type: Boolean,
    default: false,
  },
  onEnter: {
    type: Function,
    default: () => {},
  },
});

// Define emits
const emit = defineEmits(['update:modelValue']);

// Reactive state
const inputValue = ref(props.modelValue);
const inputRef = ref<HTMLInputElement | null>(null);

// Methods
const emitUpdate = () => {
  emit('update:modelValue', inputValue.value);
};

const clearInput = () => {
  inputValue.value = '';
  emit('update:modelValue', '');
  if (props.focusAfterClear && inputRef.value) {
    inputRef.value.focus();
  }
};

// Watch for changes in modelValue
watch(() => props.modelValue, (newValue) => {
  inputValue.value = newValue;
});
</script>
